/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {EventFormComponent as ɵc} from './event-form/event-form.component';
export {EventComponent as ɵb} from './event.component';
export {declaration as ɵa} from './event.module';
export {EventRoutes as ɵd} from './event.routing';